import AmenitiesTab from "./mediaGallery";

export enum TabNames {
    GeneralInfo = 'General Info',
    VinDetails = 'VIN Details',
    Allocated = 'Allocated VIN',
    OrderDetail = 'Booking / Order Details',
    ListingPrice = 'Listing Price',
    Logs = 'Logs',
    Accessories = 'Accessories',
    AttributeInfo='Attribute Info',
    MediaDocuments='Media & Documents',
    AmenitiesTab='Amenities Tab',
    People='People'
  }
  